import { FontEntry } from '../../types/font'

export const cabin: FontEntry = {
  displayName: 'Cabin',
  weights: {},
  variables: {
    normal: {
      file: 'Cabin-VariableFont_wdth,wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    },
    italic: {
      file: 'Cabin-Italic-VariableFont_wdth,wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    }
  }
}
